import {
  DeleteIcon,
  Divider,
  GKTextField,
  Grid2,
  IconButton,
  PlusIcon,
  Show,
  Typography,
} from "components";
import { AdvisorOnboardFormInterface } from "interfaces/OnboardingInterface";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";

const AdvisorOnboardingClientNominee = () => {
  const form = useFormContext<AdvisorOnboardFormInterface>();

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "nominees",
  });

  return (
    <Grid2 container spacing={1}>
      <Show.When isTrue={fields.length === 0}>
        <Typography color={"var(--neutral-500)"} fontSize={12}>
          *Please add a nominee by clicking below button.
        </Typography>
      </Show.When>
      <Show.When isTrue={fields.length !== 0}>
        <Grid2 size={12}>
          {fields.map((bank: any, index: number) => (
            <Grid2 container size={12} spacing={1} my={1} key={index}>
              <Grid2 size={3}>
                <Controller
                  name={`nominees.${index}.name`}
                  control={form.control}
                  render={({ field }) => (
                    <GKTextField {...field} inputLabel="Nominee Name" />
                  )}
                />
              </Grid2>
              <Grid2 size={3}>
                <Controller
                  name={`nominees.${index}.percentage`}
                  control={form.control}
                  render={({ field }) => (
                    <GKTextField {...field} inputLabel="Nominee Percentage" />
                  )}
                />
              </Grid2>
              <Grid2 size={3}>
                <Controller
                  name={`nominees.${index}.relationship`}
                  control={form.control}
                  render={({ field }) => (
                    <GKTextField {...field} inputLabel="Relationship" />
                  )}
                />
              </Grid2>
              <Grid2 size={3} textAlign={"right"} alignSelf={"center"} mt={2}>
                <IconButton
                  color="error"
                  disabled={fields?.length === 1}
                  onClick={() => {
                    remove(index);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Grid2>
            </Grid2>
          ))}
        </Grid2>
      </Show.When>
      <Grid2 size={12}>
        <Divider>
          <IconButton
            onClick={() =>
              append({
                name: "",
                percentage: "",
                relationship: "",
              })
            }
          >
            <PlusIcon />
          </IconButton>
        </Divider>
      </Grid2>
    </Grid2>
  );
};

export default AdvisorOnboardingClientNominee;
